import { EstadosOrdenTrabajoEnumChoice, useTableFilter, } from "@/shared";
import { useFetchOrdenTrabajos } from "@/shared/actions/erp";
import { CustomSearch, GeneralTable } from "@/shared/components/ui";
import { OrdenTrabajo, } from "@/shared/interfaces";
import { Grid } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";

type ITablaInstalacionProps = {
  columns: MRT_ColumnDef<OrdenTrabajo>[]
}

const TablaInstalacionAsignadaComponente = ({ columns }: ITablaInstalacionProps) => {


  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,

    onChangeRangeDate,
    cleanFilter,
    dateAfter,
    dateBefore,

  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  const {
    data: instalacionesAgendadasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchOrdenTrabajos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.EN_ESPERA,
      numero_referencia: searchTerm,
      fecha_creacion_before: dateBefore,
      fecha_creacion_after: dateAfter
    }
  });



  return (
    <>
      <Grid>
        <Grid item>
          <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            text="por número de referencia"

            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <GeneralTable<OrdenTrabajo>
          columns={columns}
          data={instalacionesAgendadasPagingRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={instalacionesAgendadasPagingRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          // crud
          canDelete={false}
          positionActionsColumn='first'

          //
          enableColumnActions={false}
          enableEditing={false}

        />
      </Grid>


    </>
  );

}

export default TablaInstalacionAsignadaComponente;